import { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';

import './index.css';

class NormalizedInput extends Component {
  render() {
    const { children } = this.props;
    const { className, name } = children.props;
    return cloneElement(children, {
      className: `NormalizedInput ${className}`,
      id: name,
    });
  }
}

NormalizedInput.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NormalizedInput;
